import Base from './Base';
import Helper from '../Helper';
import Note from '../../Components/Widgets/Note.svelte';
import Option from '../../Components/Widgets/Option.svelte';
import Product from '../../Stores/Product';

export default class Upgrade extends Base {
	build(list) {
		const property = this.product().property;
		if (property.notice) {
			const component = {
				component: Note,
				config: {
					title: property.notice,
					icon: 'fa-regular fa-circle-exclamation'
				}
			};

			list.push(component);
		}

		const selected = property.selected || {};
		const group = this.product().group;
		if (Array.isArray(group.values))
			for (let value of group.values) {
				const valid = selected.valid && (value.id === selected.value);
				const component = {
					component: Option,
					config: {
						id: value.id,
						title: value.value,
						badge: value.badge,
						price: value.price || Product.variationPercentage(value.percentage) || Product.variationPercentage(group.percentage),
						price_high: value.price_from || 0,
						checked: valid,
						count: !!property.quantity_enabled,
						value: valid ? (selected.count || 0) : 0,
						image: this.validImage(value.image),
						description: value.description,
						on_input: item => { this.onChange(item, group, value, selected); },
						on_click: item => { this.onChange(item, group, value, selected); },
						on_change: item => { this.onChange(item, group, value, selected); }
					}
				};

				list.push(component);
			}

		return list;
	}

	onChange(item, group, value, selected) {
		if (item.valid) {
			const percentage = Product.variationPercentage(value.percentage) || Product.variationPercentage(group.percentage);
			const price = value.price || percentage;
			item.upgrade = group.upgrade_id;
			item.price = price * (item.count || 1);

			item.basket = [];
			if (Helper.is(value.add_to_basket))
				for (let product of value.add_to_basket) {
					const content = {id: product.shop_group_product_id, count: product.count};
					item.basket.push(content);
				}
		}

		this.product().property.selected = item.valid ? item : {};
		this.update();
	}
}